import { VBaseService, VServices } from "@libVue/base";
import { CRAFT_TRANSLATIONS, SITEURL } from "@libTs/cms.globals";

export class TranslationService extends VBaseService {
    public t(key: string): string {
        try {
            if (CRAFT_TRANSLATIONS[key]) {
                return CRAFT_TRANSLATIONS[key];
            } else {
                console.warn(
                    "translation key not present in translations.twig \n",
                    `'${key}': '${key}'|t,`,
                );
                return key;
            }
        } catch (error) {
            return key;
        }
    }
}
